import appGlobalScript from '/home/runner/work/nylas/nylas/packages/nylas-web-elements/src/common/global.ts';
export const globalScripts = appGlobalScript;
